import { useCallback, useEffect, useState } from "react";

import { readJson, writeJson } from "@/utils/storage";

const KEY = "portal:recents";
const MAX = 8;

export function useRecents() {
  const [ids, setIds] = useState<string[]>(() => readJson<string[]>(KEY, []));

  useEffect(() => {
    writeJson(KEY, ids);
  }, [ids]);

  const push = useCallback((id: string) => {
    setIds((prev) => [id, ...prev.filter((x) => x !== id)].slice(0, MAX));
  }, []);

  return { recents: ids, push };
}
